export default function now() {
    return new Date().getTime();
}
